import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql, compose } from "react-apollo";
import moment from "moment";
import {
  queryGetLabelsByType,
  mutationAddLabelToCase,
  mutationDeleteLabelFromCase
} from "Apollo";
import { ShowNotice } from "Store";
import LabelList from "module-common/label-list/LabelList";

export default compose(
  graphql(queryGetLabelsByType, {
    name: "labelsData",
    options: { variables: { type: "CASE" } }
  }),
  graphql(mutationAddLabelToCase, { name: "mutateAdd" }),
  graphql(mutationDeleteLabelFromCase, { name: "mutateDelete" })
)(
  class LabelListCase extends Component {
    static propTypes = {
      id: PropTypes.number.isRequired,
      labels: PropTypes.array
    };
    render() {
      const {
        labels,
        labelsData: { getLabelTemplates: labelsPicker },
        ...rest
      } = this.props;

      // labels
      const caseLabels = [];
      for (const label of labels) {
        const currLabel = label.labelTemplate;
        if (currLabel.labelType === "CASE") {
          caseLabels.push({
            label: currLabel.displayName,
            color: "#" + currLabel.color,
            value: currLabel
          });
        }
      }
      // sort by order and date
      caseLabels.sort((a, b) => {
        if (a.value.order !== b.value.order) {
          return a.value.order > b.value.order;
        } else {
          return moment(a.value.dateCreated).isAfter(b.value.dateCreated);
        }
      });

      // option for picker
      const pickers = [];
      if (labelsPicker) {
        for (const label of labelsPicker) {
          pickers.push({
            label: label.displayName,
            color: "#" + label.color,
            value: label
          });
        }
      }

      return (
        <LabelList
          labels={caseLabels}
          pickers={pickers}
          onAdd={this.onAdd}
          onRemove={this.onRemove}
          {...rest}
        />
      );
    }

    onAdd = async label => {
      const { id, mutateAdd } = this.props;
      try {
        await mutateAdd({
          variables: {
            case: { id: id },
            labels: [{ id: label.value.id }]
          }
        });
        ShowNotice("label-add-success");
      } catch (error) {
        ShowNotice("label-add-error");
      }
    };

    onRemove = async label => {
      const { id, mutateDelete } = this.props;
      try {
        await mutateDelete({
          variables: {
            case: { id: id },
            labels: [{ id: label.value.id }]
          }
        });
        ShowNotice("label-delete-success");
      } catch (error) {
        ShowNotice("label-delete-error");
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/LabelListCaseWithQueryMutation.js